import React from 'react'
import {Box} from '../../webui/Box'
import {LoadingSpinnerContainer} from '../../webui/progress/LoadingSpinnerContainer'
import {useAllRentals} from '../rentals/gql/useAllRentals'
import ProductChangeTable from './ProductChangeTable'

interface Props {
  boxId: string
}

export const ProductChange: React.FC<Props> = ({boxId}) => {
  const {
    data: {rentals},
    loading,
    error,
  } = useAllRentals({
    variables: {
      filter: {boxIds: [boxId]},
      pagination: {offset: 0, limit: 2000},
    },
  })

  if (loading) return <LoadingSpinnerContainer />
  if (error) return <div>{error.message}</div>

  return (
    <Box alignItems={'center'} justifyContent={'space-between'} display={'flex'} p={2}>
      <ProductChangeTable rentals={rentals ?? []} />
    </Box>
  )
}
